import Filter from '__core/shared/model/filter/Filter';
import { FilterType } from '__core/shared/model/filter/Filter.enum';
import stFiltersList from './filtersList.component';

export default angular
  .module('st.Filter', ['st.Core', 'angular-cache'])
  .factory('Filter', () => Filter)
  .factory('FilterType', () => FilterType)
  .component('stFiltersList', stFiltersList)
  .service('filterService', (Filter, dataService) => ({
    createFilter: (doc) => dataService.createDocument(Filter, doc),
    readFilter: (doc) => dataService.readDocument(Filter, doc),
    updateFilter: (doc) => dataService.updateDocument(Filter, doc),
    deleteFilter: (doc) => dataService.deleteDocument(Filter, doc),
    itemIsActiveValue: ({ filterWith }) => {
      if (_.isEmpty(filterWith)) {
        return null;
      }
      const filterItem = _.find(filterWith.items, (i) => i.path === 'isActive');
      if (_.isEmpty(filterItem)) {
        return null;
      }

      const filterItemOperator = _.get(filterItem, 'operator.name');
      const filterItemOperatorValue = filterItemOperator === 'eq' ? 'true' : 'false';
      return _.head(_.get(filterItem, 'values')) === filterItemOperatorValue;
    },
    modelCompose: (data, template, validValues) => {
      const output = angular.copy(template);
      output.name = _.get(data, 'name') || '';
      _.forIn(output, (fi, fk) => {
        if (_.isObject(fi)) {
          // Remap Values from Filter back to Model used on UI
          const filterItem = _.find(
            data.items,
            (i) =>
              i.path === fi.path &&
              i.type.name === fi.type.name &&
              i.operator.name === fi.operator.name
          );
          const filterItemValues = _.get(filterItem, 'values') || [];
          const filterItemValidValues = _.map(_.get(validValues, `${fk}`), 'id');
          // Remap values back to Bools or keep them as Strings
          output[fk].values =
            _.get(filterItem, 'type.name') === 'bool'
              ? _.map(filterItemValues, (v) => v === 'true')
              : filterItemValues;
          // Remove all values which are not valid, if valid values are provided
          if (!_.isEmpty(output[fk].values) && !_.isEmpty(filterItemValidValues)) {
            output[fk].values = _.intersection(output[fk].values, filterItemValidValues);
          }
          output[fk].operatorNot = _.get(filterItem, 'operatorNot') === true;
        }
      });
      return output;
    },
    modelDecompose: (model) => {
      const output = _.filter(
        _.compact(_.uniq(_.values(model))),
        (v) =>
          v.values &&
          v.values.length &&
          // Do not retrieve String values which are empty BC/ deletion of text
          (v.type.name !== 'str' ||
            (v.type.name === 'str' && !_.some(v.values, (v) => _.isEmpty(v)))) &&
          // Do not retrieve Number values which are zeros BC/ Dates
          (v.type.name !== 'num' ||
            (v.type.name === 'num' &&
              (!_.every(v.values, (v) => v === 0) ||
                !_.every(v.values, (v) => _.isEmpty(v))))) &&
          // Do not retrieve Boolean values which are false BC/ CheckBoxes
          (v.type.name !== 'bool' ||
            (v.type.name === 'bool' && _.some(v.values, (v) => v === true)))
      );
      _.forEach(output, (fi) => {
        // Remap Objects to ID Array
        if (_.isObject(fi.values[0])) {
          output[output.indexOf(fi)].values = _.map(fi.values, 'id');
        }
        // Remap All values to Strings
        if (!_.isString(fi.values[0])) {
          output[output.indexOf(fi)].values = _.map(fi.values, (v) => v.toString());
        }
      });
      return output;
    }
  }))
  .service('filtersService', ($http, $rootScope, CacheFactory, dataService, Filter, FILTER) => {
    let cache;
    if (!CacheFactory.get(FILTER.CACHE.NAME)) {
      cache = CacheFactory(FILTER.CACHE.NAME, FILTER.CACHE.STORE);
    }
    const cacheKey = (params, requestName) =>
      JSON.stringify({
        idAccount: $rootScope.CurrentAccount.id,
        idOrganization: $rootScope.CurrentOrganization.id,
        type: requestName || FILTER.CACHE.NAME,
        params
      });
    return {
      clearCache: () => cache.removeAll(),
      getAvailable: (params) =>
        dataService.apiRequest(
          cache,
          cacheKey(params, 'getAvailable'),
          params?.ignoreCache === true,
          Filter.build,
          $http.get,
          FILTER.API.AVAILABLE,
          { params }
        )
    };
  })
  .constant('FILTER', {
    API: {
      AVAILABLE: '/api/v1/filters/available/'
    },
    CACHE: {
      NAME: 'filtersCache',
      STORE: {
        maxAge: 60 * 1000,
        deleteOnExpire: 'aggressive',
        recycleFreq: 30 * 1000,
        storageMode: 'sessionStorage'
      }
    }
  });
